import Vue from 'vue'
import VueRouter from 'vue-router';
import MainView from '@/components/MainView';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'MainView',
        component: MainView
    },
    {
        path: '/selectpart/:partId',
        name: 'SelectPart',
        component: MainView
    },
    {
        path: '/selectpartorrootdrawing/:partId',
        name: 'SelectPartOrSelectRootDrawing',
        component: MainView
    },
    {
        path: '/selectorshowdrawing/:drawingId',
        name: 'SelectOrShowDrawing',
        component: MainView
    },
    {
        path: '/selectdrawing/:drawingId',
        name: 'SelectDrawing',
        component: MainView
    },
    {
        path: '/showdrawing/:drawingId/:hotspotId',
        name: 'ShowHotspot',
        component: MainView
    },
    {
        path: '/showdrawing/:drawingId',
        name: 'ShowDrawing',
        component: MainView
    }
];

const router = new VueRouter({
    routes
});

export default router
